// Where this app lives on its host.
//
// Hiring is served under /hiring/ on every host (EQUALL-SHELL-AND-DOMAINS.md):
// Caddy sends /hiring/api/* to the API and /hiring/* to these screens, and the
// legacy hiring.dpspuneeast.com redirects any other path to /hiring{uri}.
//
// Read from the address rather than baked in, so the same bundle also works if
// it is ever served at the root (a local `npm start`, or a box whose Caddy has
// not been moved over yet): at the root it is '' and everything is exactly as
// it was before the move.
export const APP_BASE =
  typeof window !== 'undefined' && /^\/hiring(\/|$)/.test(window.location.pathname)
    ? '/hiring'
    : '';

/* Hiring's own app for one school: hiring.<school>.equaos.in (Sanjoy, 3 Oct
   2026), and hiring.<school>.localhost to try it locally. Returns that
   school's own address, where its one sign-in lives, or null anywhere else
   (the ERP, the legacy domain, a local `npm start`). hiring.equaos.in names
   no school, so it is not one. */
// @story HIR-SYS1
export function schoolAddressFor(loc) {
  if (!loc || !loc.hostname) return null;
  const labels = String(loc.hostname).toLowerCase().split('.');
  if (labels[0] !== 'hiring') return null;
  const rest = labels.slice(1);
  const live = rest.length >= 3 && rest.slice(-2).join('.') === 'equaos.in';
  const local = rest.length >= 2 && rest[rest.length - 1] === 'localhost';
  if (!live && !local) return null;
  const protocol = loc.protocol === 'http:' ? 'http:' : 'https:';
  return `${protocol}//${rest.join('.')}${loc.port ? `:${loc.port}` : ''}`;
}

export const SCHOOL_ADDRESS = typeof window !== 'undefined' ? schoolAddressFor(window.location) : null;

/* The platform tier: the ERP at erp.equaos.in, where the platform's owners
   see across schools (Sanjoy, 3 Oct 2026). A local `npm start` counts, so
   the cross-school views can be worked on. Anywhere else, no cross-school
   controls: at a school's address the API reads that school only. */
export function isPlatformTier(hostname) {
  const h = String(hostname || '').toLowerCase();
  return h.startsWith('erp.') || h === 'localhost' || h === '127.0.0.1';
}

export const PLATFORM_TIER = typeof window !== 'undefined' && isPlatformTier(window.location.hostname);

// Where Hiring's API is. On the school's own Hiring app the screens own the
// whole address from '/', and /api, /auth and /v1 there belong to the
// gateway (the platform's one sign-in), so the API stays at /hiring/api, as
// it is on every other host.
export const API_ROOT = SCHOOL_ADDRESS ? '/hiring' : APP_BASE;
